import React from 'react';
import { ArrowLeft } from 'lucide-react';

const TermsPage = () => {
  const currentDate = '25 August 2026';
  
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-cyan-500/20">
        <nav className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors">
              <ArrowLeft size={20} />
              <span className="text-sm">Back to Home</span>
            </a>
            <span className="text-2xl font-bold">
              <span className="text-cyan-400 neon-text">EFAM</span>
            </span>
          </div>
        </nav>
      </header>

      {/* Content */}
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-6 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-cyan-400 text-center mb-4">
            TERMS OF SERVICE
          </h1>
          <p className="text-sm text-gray-500 text-center mb-12">Last Updated: {currentDate}</p>

          <div className="text-gray-300 leading-relaxed space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">1 Agreement to Terms</h2>
              <p>By accessing and using the EFAM website and purchasing EFAM products, you agree to be bound by these Terms of Service and all applicable Australian laws and regulations If you do not agree with any of these terms, you are prohibited from using this site</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">2 Business Information</h2>
              <p>EFAM operates as an Australian business supplying electromagnetic muscle stimulation (EMS) equipment and, when released, red-light equipment</p>
              <p className="mt-2"><strong>Business Name:</strong> EASY FITNESS & MASSAGE<br/>
              <strong>ABN:</strong> 88 644 774 778<br/>
              <strong>Location:</strong> Footscray, Victoria 3011, Australia<br/>
              <strong>Email:</strong> efamfitness@gmail.com<br/>
              <strong>Phone:</strong> 0490 792 050 (9am-5pm)</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">3 Product Information and Pricing</h2>
              <p>All prices are displayed in Australian Dollars (AUD). Australian GST is included where legally applicable. International customers may be responsible for destination taxes, customs duties, brokerage charges or import requirements. Product specifications, features, availability and prices may change, but EFAM will confirm material order details before fulfilment</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">4 Orders and Payment</h2>
              <p>By placing an order, you offer to purchase the product(s) at the stated price We reserve the right to accept or decline any order Payment is processed securely through Stripe All payments must be completed before order processing begins</p>
              <p className="mt-2"><strong>Payment Methods Accepted:</strong> Credit cards, debit cards (via Stripe)<br/>
              <strong>Currency:</strong> Australian Dollars (AUD)<br/>
              <strong>Tax:</strong> Australian GST is included where required; destination taxes or duties may apply to international orders</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">5 Shipping and Delivery</h2>
              <p><strong>Express Worldwide (estimated 2-4 weeks):</strong> Express freight is included in the displayed product price. Any destination customs duties, taxes, brokerage charges or import approvals are the customer's responsibility unless EFAM confirms otherwise in writing</p>
              <p className="mt-2">Delivery timeframes are estimates only EFAM is not liable for delays caused by customs, shipping carriers, or circumstances beyond our control</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">6 Returns and Refunds</h2>
              <p>Please refer to our separate <a href="/refund-policy" className="text-cyan-400 underline">Refund Policy</a> for detailed information about returns, refunds, and change of mind provisions under Australian Consumer Law</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">7 Australian Consumer Law</h2>
              <p>Our products come with guarantees that cannot be excluded under the Australian Consumer Law You are entitled to a replacement or refund for a major failure and compensation for any other reasonably foreseeable loss or damage You are also entitled to have the products repaired or replaced if they fail to be of acceptable quality and the failure does not amount to a major failure</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">8 Warranty</h2>
              <p>All EFAM products include manufacturer warranty coverage Specific warranty terms are provided with each product and in your user manual Warranty coverage includes parts and labor for manufacturing defects under normal use conditions</p>
              <p className="mt-2"><strong>Warranty does NOT cover:</strong></p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Damage from misuse, abuse, or unauthorized modifications</li>
                <li>Normal wear and tear</li>
                <li>Damage during shipping (covered separately by carrier insurance)</li>
                <li>Use outside the product's stated domestic or commercial rating, operating instructions or intended purpose</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">9 Medical Disclaimer</h2>
              <p><strong>IMPORTANT:</strong> EFAM products are not medical devices and are not intended to diagnose, treat, cure, or prevent any disease Always consult qualified healthcare professionals before beginning any new fitness, recovery, or EMS protocol</p>
              <p className="mt-2">EMS technology is not suitable for everyone See our <a href="/safety" className="text-cyan-400 underline">Safety Information</a> page for contraindications and medical clearance requirements</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">10 Limitation of Liability</h2>
              <p>To the maximum extent permitted by Australian law, EFAM shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from the use or inability to use our products Our total liability shall not exceed the purchase price of the product</p>
              <p className="mt-2">This limitation does not affect your rights under Australian Consumer Law</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">11 Intellectual Property</h2>
              <p>All content on this website, including text, graphics, logos, images, and software, is the property of EFAM and protected by Australian and international copyright laws You may not reproduce, distribute, or create derivative works without express written permission</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">12 Privacy</h2>
              <p>Your privacy is important to us Please review our <a href="/privacy-policy" className="text-cyan-400 underline">Privacy Policy</a> to understand how we collect, use, and protect your personal information</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">13 Governing Law</h2>
              <p>These Terms of Service are governed by and construed in accordance with the laws of Victoria, Australia Any disputes arising from these terms or the use of our products shall be subject to the exclusive jurisdiction of the courts of Victoria, Australia</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">14 Changes to Terms</h2>
              <p>We reserve the right to modify these Terms of Service at any time Changes will be effective immediately upon posting to this website Your continued use of the site after changes constitutes acceptance of the modified terms</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">15 Contact Information</h2>
              <p>For questions about these Terms of Service, please contact us at:</p>
              <p className="mt-2"><strong>Email:</strong> efamfitness@gmail.com<br/>
              <strong>Phone:</strong> 0490 792 050 (9am-5pm)</p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-800 py-8">
        <div className="container mx-auto px-6 text-center">
          <p className="text-gray-500 text-sm">© {new Date().getFullYear()} EFAM All rights reserved</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
